module.exports = __webpack_public_path__ + "img/streak-fire.f28189ba.svg";